import React from 'react';
import { ValidationIcon } from '../../../icons';
import { handleCepMaskOnInput } from '../../../../utils/payment/masks';

interface ZipCodeFieldProps {
  value: string;
  error?: string;
  isFetching: boolean;
  isValid: boolean;
  onChange: (value: string) => void;
  city?: string;
  state?: string;
}

const ZipCodeField: React.FC<ZipCodeFieldProps> = ({
  value,
  error,
  isFetching,
  isValid,
  onChange,
  city,
  state,
}) => {
  const inputBaseClass = 'w-full p-3 border rounded-md shadow-sm text-sm focus:ring-primary focus:border-primary bg-input-bg-light dark:bg-input-bg-dark text-text-primary dark:text-gray-200 placeholder-gray-400 dark:placeholder-gray-500';
  const errorBorderClass = 'border-red-500';
  const normalBorderClass = 'border-medium-gray dark:border-gray-600';

  return (
    <div className="flex">
      <div className="sm:col-span-1 relative">
        <label htmlFor="zipCode" className="block text-sm font-medium text-text-secondary dark:text-gray-400 mb-1">
          CEP
        </label>
        <div className="relative">
        <input
          type="text"
          name="zipCode"
          id="zipCode"
          value={value}
          inputMode="numeric"
          required
          onChange={(evt) => onChange(evt.target?.value)}
          placeholder="00000-000"
          minLength={8}
          maxLength={9}
          onInput={handleCepMaskOnInput}
          className={`${inputBaseClass} ${error ? errorBorderClass : normalBorderClass}`}
          aria-describedby={error ? 'zipCode-error' : undefined}
          autoComplete="postal-code"
        />
        {isFetching && (
          <span className="absolute right-3 top-10 text-xs text-primary">
            Buscando...
          </span>
        )}
        <ValidationIcon isValid={isValid} showCondition={!isFetching} />
        {error && (
          <p id="zipCode-error" className="text-xs text-red-500 mt-1">
            {error}
          </p>
        )}
        </div>
        {/* Exibição da cidade e estado abaixo do CEP */}
        {city && state && (
          <div className="mt-2 text-sm text-text-secondary dark:text-gray-300">
            <span className="font-medium">{city} / {state}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ZipCodeField; 